import React,{useState, useEffect} from 'react';
// import store from './store';
import * as Actions from '../../Actions';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as comMod from '../../commonModule';
import * as albCM from '../../albCommonModule';
import { LoadingSpinner, LoadErr} from '../common/commonParts';
import * as mui from '../common/materialUi'
import UserDialog from './UserDialog';
import UserSortDialog from './UserSortDialog';
import SnackMsg from '../common/SnackMsg';
import { LinksTab } from '../common/commonParts';
import { useHistory, useLocation, useParams, } from 'react-router-dom';
import UserEditNoDialog from './UserEditNoDialog';
import { red, yellow } from '@material-ui/core/colors';


const OtherOfficies = (props) => {
  const {type, uetc} = props;
  let officeis = [];
  if (type === '管理事業所'){
    officeis = uetc && uetc.協力事業所? uetc.協力事業所: [];
  }
  else if (type === '協力事業所'){
    officeis = uetc && uetc.管理事業所? uetc.管理事業所: [];
  }
  const st = {
    fontSize: '.8rem', 
    // overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis',
    paddingBottom: 2,
    width: '100%'
  };
  const elms = officeis.map(e=>{
    return (
      <div style={st}>{e.name}</div>
    )
  })
  return (
    <div>
      {elms}
    </div>
  )
}

const UserListTitle =(props)=> {
  const {classroomCnt, brosCnt, uprms} = props;
  // 教室未設定の場合は項目表示しない
  const Std = () => {
    return(
      <div className = "flxTitle oddColor" >
        <div className="wmin lower"><div>No</div></div>
        <div className="w07 lower"><div>年齢<br />学齢</div></div>
        <div className="w20 lower">
          <div>種別/サービス<br />受給者証番号</div>
        </div>
        <div className="wzen4 lower"><div>提供量</div></div>
        {classroomCnt > 0 &&
         <div className="w07 lower"><div>単位</div></div>
        }
        <div className="w10 lower"><div>上限額</div></div>
        <div className="wmin lower"><div>管</div></div>
        <div className="w20 lower"><div>氏名</div></div>
        {brosCnt > 0 &&
         <div className="w07 lower"><div>兄弟</div></div>
        }
        {(uprms !== 'kanri' && uprms !== 'bros') &&
          <div className="w20 lower"><div>保護者</div></div>
        } 
        {(uprms === 'kanri' || uprms === 'bros') &&
          <div className="w20 lower"><div>保護者・TEL</div></div>
        }
        {(uprms !== 'kanri' && uprms !== 'bros') &&
          <div className="w30 lower"><div>連絡先</div></div>
        }
        {(uprms === 'kanri' || uprms === 'bros') &&
          <div className="w30 lower"><div>管理・協力事業所</div></div>
        }
      </div >
    )
  }
  const Belongs = () => {
    return (
      <div className = "flxTitle oddColor" >
        <div className="wmin lower"><div>No</div></div>
        <div className="w07 lower"><div>年齢<br />学齢</div></div>
        <div className="w20 lower">
          <div>種別/サービス<br />受給者証番号</div>
        </div>
        <div className="w20 lower"><div>氏名</div></div>
        <div className="w20 lower"><div>保護者</div></div>
        <div className="w20 lower"><div>市区町村</div></div>
        <div className="w25 lower"><div>所属１</div></div>
        <div className="w25 lower"><div>所属２</div></div>
      </div >
    )
  }
  const BankInfo = () => {
    return (
      <div className = "flxTitle oddColor" >
        <div className="wmin lower"><div>No</div></div>
        <div className="w15 lower"><div>保護者<br></br>児童名</div></div>
        <div className="w10 lower"><div>金融機関</div></div>
        <div className="w07 lower"><div>支店</div></div>
        <div className="w07 lower"><div>種別</div></div>
        <div className="w15 lower"><div>口座番号</div></div>
        <div className="w15 lower"><div>口座名義</div></div>
        <div className="w15 lower"><div>顧客コード</div></div>
      </div >
    )
  }
  if (uprms === 'belongs')        return <Belongs/>
  else if (uprms === 'bankinfo')  return <BankInfo/>
  else return <Std/>
}

const usersMenu = [
  { link: "/users", label: "基本" },
  { link: "/users/belongs", label: "所属" },
  { link: "/users/bankinfo", label: "口座情報" },
  { link: "/users/bros", label: "兄弟表示" },
  { link: "/users/kanri", label: "管理・協力表示" },
]

// 表示を行わないコンポーネント。ローディングが終わったらuserとcomの次月以降の
// データを取得しdispatchする
export const GetNextHist = () => {
  const dispatch = useDispatch();
  const allState = useSelector(state=>state);
  const loadingStatus = comMod.getLodingStatus(allState);
  const {hid, bid, stdDate, nextUsers, nextCom} = allState;
  useEffect(()=>{
    const dispatchItems = (r) => {
      if (!r.result) return false;
      const rtnNextCom = r.fetchNextComInfo.data.dt.length
      ? r.fetchNextComInfo.data.dt[0].next: '';
      const rtnNextUsers = r.fetchNextUserInfo.data.dt.length
      ? r.fetchNextUserInfo.data.dt: [];
      dispatch(Actions.setStore({nextUsers: rtnNextUsers, nextCom: rtnNextCom}));
    }
    const {loaded, error} = loadingStatus;
    if (loaded && !error && (!nextUsers && nextCom === undefined)){
      albCM.getNextHist({hid, bid, date: stdDate})
      .then(res=>{dispatchItems(res)})
    }
  }, [loadingStatus])
  return null;
}

// 2022/08/31 変更開始
// 修正をダイアログにしない。
const UserlistElms = (props)=>{
  const dispatch = useDispatch();
  let listElms;
  const service = useSelector(state => state.service);
  const classroom = useSelector(state =>state.classroom);
  const allstate = useSelector(state => state);
  const {controleMode} = allstate;
  const permission = comMod.parsePermission(allstate.account)[0][0];
  const loadingStatus = comMod.getLodingStatus(allstate);
  const {uprms, editOn} = props;
  const hist = useHistory();
  const location = useLocation().pathname;
  const prms = useParams().p;
  // const [snack, setSnack] = useState({msg:'', severity: ''})
  
  if (!loadingStatus.loaded) return null;

  const dispClassroom = (e) => {
    const v = e.classroom;
    if (Array.isArray(v) && v.length > 1) return '複数';
    else if (v.indexOf(',') > 0)  return '複数';
    else if (Array.isArray(v) && v.length === 1) return v[0];
    else return v;
  }

  const clickHandler = (e)=>{
    // 修正モードでないときは何もしない
    if (!editOn) return false;
    const uid = e.currentTarget.getAttribute('uid');
    const root = location.replace(prms, ''); // urlからもともと与えられているprmsを削除
    const defPrms = prms? prms: '';
    // スクロール位置をdispatchして保存
    // const elm = document.querySelector('#userscroll322');
    const v = document.scrollingElement.scrollTop;
    const t = controleMode;
    t.userPaeScroll = v;
    dispatch(Actions.setStore({controleMode: t}));
    const newLoc = root.replace(/\/$/, '') + '/edit' + defPrms + uid;
    console.log(newLoc, 'newLoc');
    hist.push(newLoc);
  }
  const editonRowClass = (props.editOn) ? 'editOn ' : ' '
  const swaponRowClass = (props.swapOn)? 'swapOn ': ' '
  const OneUser = (props) => {
    const {e, i, classroomCnt, brosCnt} = props;
    const t = comMod.findDeepPath(e, 'etc.bank_info');
    const binfo = t ? t: {};
    const kariNoClass = (e.hno.length < 10) ? 'kariHno' : '';
    // 最近使ったユーザーかどうか判定してスタイルを取得
    const ruSt = albCM.recentUserStyle(e.uid);
    // 兄弟組不能だった場合のスタイルとクラス名
    const brosErrStyle = e.brosError? {color: red[900]}: {};
    const brosErr = e.brosError? ' brosErr': '';
    const serviceSw = (s) => {
      let r = '';
      s.split(',').forEach(e=>{
        r += comMod.shortWord(e) + '+';
      });
      return r.replace(/\+$/, '');
    }
    // 行の中の共通項目
    const Common = () => {
      return (<>
          <div className='wmin center' style={ruSt}>{i + 1}</div>
          <div className='w07'>{e.ageStr}</div>
          <div className='w20'>
            <div>
              {
                comMod.shortWord(e.type) +
                ' / ' +
                serviceSw(e.service)
              }
            </div>
            <div className={'small ' + kariNoClass}>{e.hno}</div>
          </div>
      </>)
    }
    const BankInfo = () => {
      return (<>
        <div 
          key={e.uid} uid={e.uid} 
          className={'userRow flxRow oddColor ' + editonRowClass + swaponRowClass}
          onClick={e=>clickHandler(e)}
        >
          <div className='wmin center'>{i + 1}</div>
          <div className='w15'>
            <div>{e.pname}</div>
            <div className='small'>{e.name}</div>
          </div>
          <div className='w10'>{binfo.金融機関番号}</div>
          <div className='w07'>{binfo.店舗番号}</div>
          <div className='w07'>{binfo.預金種目}</div>
          <div className='w15'>{binfo.口座番号}</div>
          <div className='w15'>{binfo.口座名義人}</div>
          <div className='w15'>{binfo.顧客コード}</div>
        </div>
      </>)
    }
    const Belongs = () => {
      return (
        <div 
          key={e.uid} uid={e.uid} 
          className={'userRow flxRow oddColor ' + editonRowClass + swaponRowClass}
          onClick={e=>clickHandler(e)}
        >
          <Common/>
          <div className='w20'>
            <div>{e.name}</div>
            <div className='small'>{e.kana}</div>
          </div>
          <div className='w20'>
            <div >{e.pname}</div>
            <div className='small'>{e.pkana}</div>
          </div>
          <div className='w20'>
            <div>{e.scity}</div>
            <div className='small'>{e.scity_no}</div>
          </div>
          <div className='w25'>
            <div>{e.belongs1}</div>
          </div>
          <div className='w25'>
            <div>{e.belongs2}</div>
          </div>
        </div>

      )
    }
    // 長すぎると表示が乱れるので
    const mailText = e.pmail.length > 25? e.pmail.slice(0,25) + '..': e.pmail;

    const Std = () =>{
      // 兄弟表示のときは電話番号を表示する
      const pinfo = uprms === 'bros'? e.pphone: e.pkana;
      return (
        <div 
          key={e.uid} uid={e.uid} 
          className={'userRow flxRow oddColor ' + editonRowClass + swaponRowClass}
          onClick={e=>clickHandler(e)}
        >
          <Common/>
          <div className='wzen4 right'>{e.volumeStd? '0': e.volume}</div>
          {/* 教室未設定の場合は項目表示しない */}
          {/* 複数指定の場合ストアステイトに一致しているものだけ表示する */}
          {classroomCnt > 0 &&
            <div className='w07'>{dispClassroom(e)}</div>
          }
          <div className='w10 right'>
            {comMod.formatNum(e.priceLimit, 1)}
          </div>
          <div className="wmin">{e.kanri_type.substr(0, 1)}</div>
          <div className='w20'>
            <div>{e.name}</div>
            <div className='small'>{e.kana}</div>
          </div>
          {brosCnt > 0 &&
            <div className={'w07 right' + brosErr} style={brosErrStyle}>
              {e.brosIndex}
            </div>
          }
          <div className='w20'>
            <div style={brosErrStyle}>{e.pname}</div>
            <div className='small' style={brosErrStyle}>{pinfo}</div>
          </div>
          <div className='w30'>
            {(uprms !== 'kanri' && uprms !== 'bros') && <>
              <div style={brosErrStyle}>{e.pphone}</div>
              <div className='small'>{e.pphone1}</div>
              <div className='small'>
                <a href={'mailto:'+e.pmail}>{mailText}</a>
              </div>
            </>}
            {(uprms === 'kanri' || uprms === 'bros') && 
              <OtherOfficies type={e.kanri_type} uetc={e.etc}/>
            }
          </div>
        </div>
      )
    }
    if (uprms === 'belongs'){
      return <Belongs />
    }
    else if (uprms === 'bankinfo'){
      return <BankInfo />
    }
    else {
      return <Std/>
    }
  }
  // deepコピーにしないとだめらしい
  const tUsers = JSON.parse(JSON.stringify(props.users));
  // 両親の名前と電話番号をつなげた文字列の配列
  const parerents = tUsers.map(e=>e.pname+e.pphone);
  tUsers.forEach(e=>{
    // 兄弟の場合の保護者名と電話番号結合の出現回数をチェック
    if (parseInt(e.brosIndex)){
      const l = parerents.filter(f=>f === e.pname+e.pphone).length;
      if (l < 2) e.brosError = true;
    }
  });
  if (tUsers.find(e=>e.brosError)){
    props.setBrosErrExist(true);
    // setSnack({msg: '兄弟設定を見直す必要があります', severity: 'warning'})
  }  
  if (loadingStatus.loaded && !loadingStatus.error) {
    const users = tUsers.filter(e => {
      if (albCM.isService(e, service) && albCM.isClassroom(e, classroom)){
        return (e);
      }
    });
    listElms = users.map((e, i) => {
      if (e.delete)  return null;
      // 仮保険番号であることを示すクラス設定
      const kariNoClass = (e.hno.length < 10) ? 'kariHno' : '';
      return (
        <OneUser 
          e={e} i={i} key={i}
          classroomCnt={props.classroomCnt} brosCnt={props.brosCnt} 
        />
      );
    });
  }
  else if (loadingStatus.error) {
    listElms = (
      <LoadErr loadStatus={loadingStatus} errorId={'E4931'} />
    )
  }
  else{
    listElms = (<LoadingSpinner />);
  }
  if (listElms.length){
    return (
      <div className='tabelBodyWrapper' >
        {listElms}
        {/* <SnackMsg {...snack} /> */}
      </div>
    );
  }
  else {
    const style = {textAlign: 'center', padding: 16}
    return (
      <div className='tabelBodyWrapper' >
        <div style={style}>
          表示するユーザーが見つかりません。
        </div>
      </div>
    );
  }
}
// ユーザーリストを表示するエレメントを作成
// storeからユーザーリストの配列を取得して表示
// 放デイ、自発のサービスごとにするか全部出すかを判断する
// stateのserviceが空白なら全表示
// usersからrenderを独立させた
// export const UsersOld = ()=>{
//   const dispatch = useDispatch();
//   // 編集ボタンの状態を保持するため
//   const cntMode = useSelector(state=>state.controleMode);
//   const prms = useParams().p;
//   const hist = useHistory();
//   const location = useLocation().pathname;

//   // 編集用ダイアログの制御
//   const [open, setopen] = useState(false);
//   const [userSortOpen, setUserSortOpen] = useState(false);
//   const [userSortRes, setUserSortRes] = useState({});
//   const [uids, setuids] = useState('');
//   const [editOn, seteditOn] = useState(()=>{
//     if (!cntMode.usersFabEdit){
//       return false;
//     }
//     else return true;
//   });
//   const [snack, setSnack] = useState({msg:'', severity: ''});
//   const [brosErrExist, setBrosErrExist] = useState(false); // 兄弟組不能があるかどうかを格納
//   // const [swapOn, setswapOn] = useState(false);
//   const users = useSelector(state => state.users);
//   const stdDate = useSelector(state=>state.stdDate);
//   const controleMode = useSelector(state=>state.controleMode);
//   const uprms = useParams().p; // url パラメータ取得
//   let fusers;
//   if (uprms === 'bros'){
//     fusers = users.filter(e=>parseInt(e.brosIndex));
//     fusers.sort((a, b)=>(a.pname + a.brosIndex < b.pname + b.brosIndex? -1 : 1));
//   }
//   else if (uprms === 'kanri'){
//     fusers = users.filter(e=>e.kanri_type);
//     fusers.sort((a, b)=>(a.kanri_type > b.kanri_type? -1 : 1));
//   }
//   else{
//     fusers = [...users];
//   }
//   // 設定済み教室のカウント 0ならば一覧に教室を表示しない
//   const classroomCnt = users.filter(e=>e.classroom).length;
//   // 設定済みの兄弟のカウント 0ならば一覧に表示しない
//   const brosCnt = users.filter(e=>parseInt(e.brosIndex) > 0).length;
//   const fabClickHandler = (e)=>{
//     const name = e.currentTarget.name;
//     if (name === 'edit' && editOn){
//       seteditOn(false);
//       dispatch(Actions.setStore({controleMode:{usersFabEdit: false}}))
//     };
//     if (name === 'edit' && !editOn) {
//       seteditOn(true);
//       setUserSortOpen(false);
//       dispatch(Actions.setStore({controleMode:{usersFabEdit: true}}))
//     };
//     // if (name === 'swap' && swapOn) {
//     //   setUserSortOpen(false);
//     // };
//     if (name === 'swap') {
//       setUserSortOpen(true);
//       seteditOn(false);
//     };
//     if (name === 'add') {
//       // setopen(true); 
//       // seteditOn(false);
//       // setuids('');
//       const root = location.replace(prms, ''); // urlからもともと与えられているprmsを削除
//       const defPrms = prms? prms: '';
//       const newLoc = root.replace(/\/$/, '') + '/addnew' + defPrms;
//       console.log(newLoc, 'newLoc');
//       hist.push(newLoc);
//     }
//   }
//   useEffect(() => {
//     // console.log('res', userSortRes);
//     if (Object.keys(userSortRes).length) {
//       if (userSortRes.data.resulttrue && !userSortRes.data.resultfalse) {
//         dispatch(Actions.setSnackMsg('利用者の順番を登録しました。', ''));
//       }
//       else {
//         dispatch(Actions.setSnackMsg(
//           '利用者の順番を登録できませんでした。', 'error'
//         ));
//       }
//     }
//   }, [userSortRes]);
//   useEffect(()=>{
//     // スクロール量を復元
//     const prescroll = controleMode.userPaeScroll? controleMode.userPaeScroll: 0;
//     if (prescroll){
//       document.scrollingElement.scrollTop = prescroll;
//     }
//     // 直前に追加されたユーザーを検出しrecentuserにする
//     const au = controleMode.appendUser;
//     const nts = new Date().getTime();
//     // ローディングが完了していない状態は何もしない
//     if (!users && !users.length){
//       return false;
//     }
//     // 直近に追加されたユーザーを検出できたとき
//     if (au && au.ts && nts - au.ts < 1000){
//       const t = users.find(e=>e.hno === au.hno);
//       if (t) albCM.setRecentUser(t.uid);
//     }
//   },[]);
//   // 兄弟・管理協力表示のときのメッセージ
//   useEffect(()=>{
//     if (uprms === 'bros' || uprms === 'kanri'){
//       setSnack({
//         ...snack, 
//         msg: 'この画面から管理事業所・協力事業所の編集は出来ません。',
//         id: new Date().getTime(),
//       })
//     }
//   }, [uprms])

//   if (prms && prms.includes('edit')){
//     return <UserEditNoDialog editOn={editOn}/>
//   }
//   if (prms && prms.includes('addnew')){
//     return <UserEditNoDialog editOn={false}/>
//   }
//   // 管理表示と兄弟表示は追加禁止
//   const hideAdd = uprms === 'bros' || uprms === 'kanri'? true: false
//   return (<>
//     <LinksTab menu={usersMenu} />
//     <div className='AppPage userLst fixed'>
//       <UserListTitle 
//         classroomCnt={classroomCnt} brosCnt={brosCnt} 
//         uprms={uprms}
//       />
//     </div>
//     <div className='AppPage userLst scroll' id='userscroll322'>
//       <UserlistElms 
//         users={fusers} stdDate={stdDate}
//         editOn={editOn}
//         open={open} setopen={setopen}
//         uids={uids} setuids={setuids}
//         uprms={uprms}
//         setSnack={setSnack}
//         classroomCnt={classroomCnt} brosCnt={brosCnt}
//         // setSnack={setSnack}
//         setBrosErrExist={setBrosErrExist}
//       />
//       {brosErrExist === true &&
//         <div style={{padding:8, color: red[900]}}>
//           兄弟順位や保護者名などが赤く表示されているときは兄弟設定に問題がある場合があります。
//           設定の見直しをお勧めします。
//         </div>
//       }
//       <mui.FabAddEdit 
//         clickHandler={e => fabClickHandler(e)} 
//         editOn={editOn} hideAdd={hideAdd}
//         // swapOn={swapOn}
//       />
//       <UserDialog 
//         open={open} setopen={setopen} 
//         uids={uids} setuids={setuids} 
//         editOn={editOn}
//       />
//       <UserSortDialog
//         open={userSortOpen} setopen={setUserSortOpen}
//         res={userSortRes} setres={setUserSortRes}
//         uids={uids} setuids={setuids}
//       />
//     </div>
//     <GetNextHist />
//     <SnackMsg {...snack} />
//   </>)
// }

// 作り直しトライ
// usersとusersMainに分ける
const UsersMain = () => {
  const dispatch = useDispatch();
  // 編集ボタンの状態を保持するため
  const cntMode = useSelector(state=>state.controleMode);
  const prms = useParams().p;
  const hist = useHistory();
  const location = useLocation().pathname;

  // 編集用ダイアログの制御
  const [userSortOpen, setUserSortOpen] = useState(false);
  const [userSortRes, setUserSortRes] = useState({});
  const [uids, setuids] = useState('');
  const [editOn, seteditOn] = useState(()=>{
    if (!cntMode.usersFabEdit){
      return false;
    }
    else return true;
  });
  const [snack, setSnack] = useState({msg:'', severity: ''});
  const [brosErrExist, setBrosErrExist] = useState(false); // 兄弟組不能があるかどうかを格納
  // const [swapOn, setswapOn] = useState(false);
  const users = useSelector(state => state.users);
  const stdDate = useSelector(state=>state.stdDate);
  const controleMode = useSelector(state=>state.controleMode);
  const uprms = useParams().p; // url パラメータ取得
  let fusers;
  if (uprms === 'bros'){
    fusers = users.filter(e=>parseInt(e.brosIndex));
    fusers.sort((a, b)=>(a.pname + a.brosIndex < b.pname + b.brosIndex? -1 : 1));
  }
  else if (uprms === 'kanri'){
    fusers = users.filter(e=>e.kanri_type);
    fusers.sort((a, b)=>(a.kanri_type > b.kanri_type? -1 : 1));
  }
  else{
    fusers = JSON.parse(JSON.stringify(users));
  }
  // 設定済み教室のカウント 0ならば一覧に教室を表示しない
  const classroomCnt = users.filter(e=>e.classroom).length;
  // 設定済みの兄弟のカウント 0ならば一覧に表示しない
  const brosCnt = users.filter(e=>parseInt(e.brosIndex) > 0).length;
  const fabClickHandler = (e)=>{
    const name = e.currentTarget.name;
    if (name === 'edit' && editOn){
      seteditOn(false);
      dispatch(Actions.setStore({controleMode:{usersFabEdit: false}}))
    };
    if (name === 'edit' && !editOn) {
      seteditOn(true);
      setUserSortOpen(false);
      dispatch(Actions.setStore({controleMode:{usersFabEdit: true}}))
    };
    // if (name === 'swap' && swapOn) {
    //   setUserSortOpen(false);
    // };
    if (name === 'swap') {
      setUserSortOpen(true);
      seteditOn(false);
    };
    if (name === 'add') {
      // setopen(true); 
      // seteditOn(false);
      // setuids('');
      const root = location.replace(prms, ''); // urlからもともと与えられているprmsを削除
      const defPrms = prms? prms: '';
      const newLoc = root.replace(/\/$/, '') + '/addnew' + defPrms;
      console.log(newLoc, 'newLoc');
      hist.push(newLoc);
    }
  }
  useEffect(() => {
    // console.log('res', userSortRes);
    if (Object.keys(userSortRes).length) {
      if (userSortRes.data.resulttrue && !userSortRes.data.resultfalse) {
        dispatch(Actions.setSnackMsg('利用者の順番を登録しました。', ''));
      }
      else {
        dispatch(Actions.setSnackMsg(
          '利用者の順番を登録できませんでした。', 'error'
        ));
      }
    }
  }, [userSortRes]);
  useEffect(()=>{
    // スクロール量を復元
    const prescroll = controleMode.userPaeScroll? controleMode.userPaeScroll: 0;
    if (prescroll){
      document.scrollingElement.scrollTop = prescroll;
    }
    // 直前に追加されたユーザーを検出しrecentuserにする
    const au = controleMode.appendUser;
    const nts = new Date().getTime();
    // ローディングが完了していない状態は何もしない
    if (!users && !users.length){
      return false;
    }
    // 直近に追加されたユーザーを検出できたとき
    if (au && au.ts && nts - au.ts < 1000){
      const t = users.find(e=>e.hno === au.hno);
      if (t) albCM.setRecentUser(t.uid);
    }
  },[]);
  // 兄弟・管理協力表示のときのメッセージ
  useEffect(()=>{
    if (uprms === 'bros' || uprms === 'kanri'){
      setSnack({
        ...snack, 
        msg: 'この画面から管理事業所・協力事業所の編集は出来ません。',
        id: new Date().getTime(),
      })
    }
  }, [uprms])
  if (prms && prms.includes('edit')){
    return <UserEditNoDialog editOn={editOn}/>
  }
  if (prms && prms.includes('addnew')){
    return <UserEditNoDialog editOn={false}/>
  }
  // 管理表示と兄弟表示は追加禁止
  const hideAdd = uprms === 'bros' || uprms === 'kanri'? true: false
  return (<>
    <LinksTab menu={usersMenu} />
    <div className='AppPage userLst fixed'>
      <UserListTitle 
        classroomCnt={classroomCnt} brosCnt={brosCnt} 
        uprms={uprms}
      />
    </div>
    <div className='AppPage userLst scroll' id='userscroll322'>
      <UserlistElms 
        users={fusers} stdDate={stdDate}
        editOn={editOn}
        // open={open} setopen={setopen}
        uids={uids} setuids={setuids}
        uprms={uprms}
        setSnack={setSnack}
        classroomCnt={classroomCnt} brosCnt={brosCnt}
        // setSnack={setSnack}
        setBrosErrExist={setBrosErrExist}
      />
      {brosErrExist === true &&
        <div style={{padding:8, color: red[900]}}>
          兄弟順位や保護者名などが赤く表示されているときは兄弟設定に問題がある場合があります。
          設定の見直しをお勧めします。
        </div>
      }
      <mui.FabAddEdit 
        clickHandler={e => fabClickHandler(e)} 
        editOn={editOn} hideAdd={hideAdd}
        // swapOn={swapOn}
      />
      <UserSortDialog
        open={userSortOpen} setopen={setUserSortOpen}
        res={userSortRes} setres={setUserSortRes}
        uids={uids} setuids={setuids}
      />
    </div>
    <GetNextHist />
    <SnackMsg {...snack} />
  </>)



}

// 作り直しトライ
// usersとusersMainに分ける
const Users = () => {
  const allstate = useSelector(state=>state);
  const ls = comMod.getLodingStatus(allstate);
  const com = useSelector(state=>state.com);
  if (ls.loaded && !ls.error){
    return (<UsersMain/>);
  }
  else if (!ls.loaded){
    return (<LoadingSpinner/>)
  }
  else {
    return (<LoadErr loadStatus={ls} errorId={'E49592'} />)
  }
}

export default Users;
